(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-dropdown-menu"] && !Shopify.designMode) return;
  try {
    function maInitHoverMenus() {
    var isDesktop = function () {
      return window.matchMedia('(min-width: 990px)').matches;
    };

    document.querySelectorAll('.header__menu-item-wrapper.has-dropdown').forEach(function (wrapper) {
      if (wrapper.dataset.maHoverBound) return;
      wrapper.dataset.maHoverBound = 'true';

      var headerMenu = wrapper.querySelector('header-menu');
      var details = wrapper.querySelector('header-menu details');
      if (!headerMenu || !details) return;

      var closeTimer;

      wrapper.addEventListener('mouseenter', function () {
        if (!isDesktop()) return;
        clearTimeout(closeTimer);
        if (!details.hasAttribute('open')) details.setAttribute('open', '');
      });

      wrapper.addEventListener('mouseleave', function () {
        if (!isDesktop()) return;
        closeTimer = setTimeout(function () {
          if (typeof headerMenu.close === 'function') {
            headerMenu.close();
          } else {
            details.removeAttribute('open');
          }
        }, 150);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', maInitHoverMenus);
  } else {
    maInitHoverMenus();
  }
  } catch(e) { console.error(e); }
})();

})();
